import { ServiceCategory } from "../interfaces/earnings-setup";
import { SPLOOT_BADGE_COLOR } from "../themes/badge";

export enum FORM_TYPE {
  CREATE = "create",
  EDIT = "edit"
}

// Valid image file extensions for blog images
export const VALID_IMAGE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".svg",
  ".bmp",
  ".ico",
  ".tiff",
  ".tif",
] as const;

export type ValidImageExtension = typeof VALID_IMAGE_EXTENSIONS[number];

// Service Category Options
export const SERVICE_CATEGORY_OPTIONS = [
  { value: "WALKING", label: "Walking" },
  { value: "GROOMING", label: "Grooming" },
  { value: "ACCESSORIES", label: "Accessories" },
  { value: "FOOD", label: "Food" },
  { value: "TREATS", label: "Treats" },
  { value: "HYGIENE", label: "Hygiene" },
  { value: "MISC", label: "Miscellaneous" },
] as const;

// Service Type Options by Category
export const SERVICE_TYPE_OPTIONS = {
  WALKING: [
    { value: "ONE_TIME", label: "One Time" },
    { value: "SUBSCRIPTION", label: "Subscription" },
  ],
  GROOMING: [
    { value: "ONE_TIME", label: "One Time" },
    { value: "SUBSCRIPTION", label: "Subscription" },
  ],
  FOOD: [
    { value: "PRODUCT", label: "Product" },
    { value: "FOOD_BUNDLE", label: "Food Bundle" },
    { value: "FOOD_RECIPE", label: "Food Recipe" },
  ],
  DEFAULT: [
    { value: "PRODUCT", label: "Product" },
  ],
} as const;

// Default Service Types by Category
export const DEFAULT_SERVICE_TYPES = {
  WALKING: "SUBSCRIPTION",
  GROOMING: "SUBSCRIPTION",
  FOOD: "PRODUCT",
  DEFAULT: "PRODUCT",
} as const;

// Search method options for user search
export enum SearchMethod {
  ID = "id",
  PHONE = "phone"
}

// Quick filter IDs used across the application
export enum EQuickFilterId {
  ALL_SESSIONS = "all-sessions",
  YESTERDAY = "yesterday",
  TODAY = "today",
  TOMORROW = "tomorrow",
  CUSTOM_DATE = "custom-date",
  GROOMING = "grooming",
  WALKING = "walking",
  UNASSIGNED = "unassigned",
  UNATTENDED = "unattended",
}

// Common date filter options used across multiple pages
export const COMMON_DATE_FILTER_OPTIONS = [
  {
    id: "yesterday",
    label: "Yesterday",
  },
  {
    id: "today",
    label: "Today",
  },
  {
    id: "tomorrow",
    label: "Tomorrow",
  },
  {
    id: "custom-date",
    label: "Custom Date",
  },
] as const;

export const CATEGORY_BADGE_COLORS: Record<ServiceCategory, SPLOOT_BADGE_COLOR> = {
  [ServiceCategory.WALKING]: SPLOOT_BADGE_COLOR.BLUE,
  [ServiceCategory.GROOMING]: SPLOOT_BADGE_COLOR.PURPLE,
  [ServiceCategory.PRODUCTS]: SPLOOT_BADGE_COLOR.ORANGE,
};